import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { RESEARCH } from "@/lib/data";

const ease = [0.22, 1, 0.36, 1];

export default function ResearchCorner() {
  return (
    <section
      data-testid="research-section"
      className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-10 items-end">
        <div className="col-span-12 md:col-span-6">
          <div className="overline text-[color:var(--ink-soft)] mb-4">§ Research Corner</div>
          <h2
            className="font-serif-display leading-[0.95] tracking-tight"
            style={{ fontSize: "clamp(36px, 4.8vw, 68px)" }}
          >
            Field notes for the <span className="font-italic-serif italic">amateur archivist.</span>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-6 md:pl-24">
          <p className="text-[15px] leading-[1.65] text-[color:var(--ink-soft)] max-w-md">
            Short, practical essays on genealogy technique — how to read a
            record, how to interview an elder, how to hold a photograph.
          </p>
        </div>
      </div>

      <div className="rule-strong" />
      {RESEARCH.map((r, i) => (
        <motion.a
          key={r.n}
          href="#"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.05, ease }}
          className="group grid grid-cols-12 gap-4 py-8 md:py-10 border-b border-[color:var(--ink-line)] items-baseline hover:pl-4"
          style={{ transition: "padding-left 500ms cubic-bezier(0.7, 0, 0.3, 1)" }}
          data-testid={`research-item-${i}`}
        >
          <div className="col-span-2 md:col-span-1 numeric-index text-[color:var(--ink-soft)]">
            {r.n}
          </div>
          <div className="col-span-8 md:col-span-9">
            <h3
              className="font-serif-display leading-[1.05] group-hover:text-[color:var(--rust)]"
              style={{ fontSize: "clamp(22px, 2.6vw, 40px)", transition: "color 400ms ease" }}
            >
              {r.title}
            </h3>
          </div>
          <div className="col-span-1 md:col-span-1 numeric-index text-[color:var(--ink-soft)]">{r.read}</div>
          <div className="col-span-1 md:col-span-1 flex justify-end">
            <ArrowUpRight
              size={22}
              className="transition-transform duration-500 group-hover:rotate-45 group-hover:text-[color:var(--rust)]"
            />
          </div>
        </motion.a>
      ))}
    </section>
  );
}
